import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { InlineSVGConfig } from 'ng-inline-svg-2';
import { isPlatformServer, PlatformLocation } from '@angular/common';

@Injectable()
export class SVGConfig extends InlineSVGConfig {
  // Do what ever conditions you need to set this, e.g. checking for server-side rendering
  // and only set baseURL when server-side rendered if you want.
  currentUrl
  constructor(
    @Inject('environment')
    private environment,
    @Inject(PLATFORM_ID) private platformId: string,
    private platformLocation: PlatformLocation

  ) {
    super();

    if (isPlatformServer(this.platformId)) {
      // // This code will run on the server-side
      const location = this.platformLocation as any;
            
      // this.baseUrl = `${location.protocol}//${location.hostname}`;
      this.baseUrl = `${location.protocol}//${location.hostname}:${location.port}`;
    }else{
      this.baseUrl = window?.location?.origin;
    }
    // When the server-side rendered app runs on localhost:3000, make sure baseURL is
    // http://localhost:3000 and make sure the Express server is configured properly to
    // allow the URL of the asset folders storing the SVG files.
    

    // If you don't want the directive to run on the server side.
    this.clientOnly = false;

    // If you want to bypass your HttpClient interceptor chain when fetching SVGs.
    this.bypassHttpClientInterceptorChain = true;
  }
}